import React from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";

const EmptyTable = ({ headCells }) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        {/* Table Head */}
        <TableHead>
          <TableRow>
            {headCells.map(
              (headCell, index) =>
                headCell && (
                  <TableCell
                    key={index}
                    align="center"
                    style={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    {headCell.label}
                  </TableCell>
                )
            )}
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          <TableRow>
            <TableCell colSpan={headCells.length} align="center">
              No data available
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EmptyTable;
